import { number, object, string } from "yup";
import { OperatorCommisionFeePaymentTypes, OperatorCommisionFeeValueTypes } from "../../interfaces/endpoints/trips/Trips.types";

const commissionFeeSchema = object().nullable().shape({
  fee: number()
    .transform((value) => {
      if (isNaN(value)) return undefined;
      return parseFloat(value) / 100;
    })
    .test("is-valid-percentage", "Komisioni duhet të jetë midis 0% dhe 100%", (value) => {
      if (!value && value !== 0) return true;
      return value >= 0 && value <= 1;
    })
    .nullable(),
  paymentType: number()
    .oneOf(Object.values(OperatorCommisionFeePaymentTypes).filter((x) => typeof x === "number") as number[])
    .default(OperatorCommisionFeePaymentTypes.JourneyReservation),
  valueType: number()
    .oneOf(Object.values(OperatorCommisionFeeValueTypes).filter((x) => typeof x === "number") as number[])
    .default(OperatorCommisionFeeValueTypes.Percentage)
});

export const OperatorsSchema = object().shape({
  operatorName: string().required("Vendos emrin e operatorit!"),
  headQuarters: string().required("Vendos adresën e selisë kryesore të operatorit!"),
  countryId: object().required("Vendos shtetin e vendndodhjes së operatorit!"),
  commissionFee: commissionFeeSchema
});
